import React, { useEffect } from 'react';
import { updateURLSearchParams } from '@intelligence/utils/commonUtils';
// @ts-ignore
import { storage } from '@gp/utils/utils';
import { scrollUpdatesCardIntoView } from '../utils';
import { PROJECT_DETAIL_STORAGE_KEY } from '@gp/constants/storageKeys';
import { SEGMENT_UPDATE_INFO, AUTO_SCROLL_WAITTING } from '../constants';

const getInitialUpdateId = () => {
  const searchParams = new URLSearchParams(location.search.substring(1));
  const from = searchParams.get('from');
  const updateId = searchParams.get('updateId');
  if (from === 'dpsReport' && !!updateId) {
    updateURLSearchParams({}, ['from', 'updateId']);
    return { from, updateId };
  }
  return {
    from: '',
    updateId: storage.getSessionStorageItem(PROJECT_DETAIL_STORAGE_KEY.GPOP_CACHE_UPDATE_ID_STORAGE_KEY, true),
  };
};

/**
 *
 * 从sessionStorage中读取初始granularity、date
 * 若存在，则自动滚动到granularity、date匹配上的updates卡片
 * 该交互仅作用于Update Info这个segment页面
 * @param props 配置对象
 * @param props.loading 加载状态
 * @param props.dataList updates集合
 * @param props.projectUpdateListNode updates卡片列表容器dom
 * @param props.setAllVisible 更新为全部展示
 * @param props.setSelectCategory 设置category为全部展示
 */
export default function useAutoScroll2Target(props: {
  pageContainer?: React.RefObject<HTMLElement | null>;
  segment: string;
  loading: boolean;
  dataList: any[];
  projectUpdateListNode: React.RefObject<HTMLDivElement | null>;
  setAllVisible: () => void;
  setSelectCategory: React.Dispatch<React.SetStateAction<string>>;
}) {
  const { pageContainer, segment, loading, dataList, projectUpdateListNode, setAllVisible, setSelectCategory } = props;

  useEffect(() => {
    if (segment !== SEGMENT_UPDATE_INFO) return;
    if (loading) return;
    if (!Array.isArray(dataList) || !dataList.length) return;
    const { updateId: initialUpdateId } = getInitialUpdateId();
    if (!initialUpdateId) return;
    const dataItemIdx = dataList.findIndex((dataItem) => {
      const { update_id: updateId } = dataItem || {};
      return updateId === initialUpdateId;
    });

    if (dataItemIdx !== -1) {
      setSelectCategory('all');
      setAllVisible();

      setTimeout(() => {
        if (!projectUpdateListNode.current) return;
        scrollUpdatesCardIntoView(pageContainer, dataItemIdx);
      }, AUTO_SCROLL_WAITTING);
    }
  }, [segment, loading, dataList]);
}
